export default __webpack_public_path__ + "static/media/product.9ce95f33.svg";